<template>
  <div id="contratos-toolbar-contratos-ejecucion">
    <v-toolbar flat>
      <v-btn
        v-if="mostrarBtnRegresar"
        icon>
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title class="display-1">
        {{ titulo }}
      </v-toolbar-title>
    </v-toolbar>
  </div>
</template>

<script>
export default {
  name: 'TituloToolBarContratoEjecucion',
  props: {
    titulo: {
      type: String,
      required: false,
      default: 'Reportes',
    },
    mostrarBtnRegresar: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
